import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { bookTheSlot, getAvailableSlot } from "./talkToExpert";
import { Slots } from "@/store/types/talkToExpertTypes";

interface TalkToExpertState {
	details: unknown;
	availableSlots: Slots[];
	counsellorId: string;
	loading: boolean;
	isOpen: boolean;
}

const initialState: TalkToExpertState = {
	details: {},
	counsellorId: "",
	availableSlots: [],
	loading: false,
	isOpen: false,
};

const talkToExpertSlice = createSlice({
	name: "talkToExpert",
	initialState,
	reducers: {
		clearTalkToExpert: () => initialState,
		setTalkToExpertOpen: (state, action: PayloadAction<boolean>) => {
			state.isOpen = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(bookTheSlot.pending, (state) => {
				state.loading = true;
			})
			.addCase(bookTheSlot.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(bookTheSlot.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAvailableSlot.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAvailableSlot.fulfilled, (state, action) => {
				state.loading = false;
				state.availableSlots = action.payload.list;
				state.counsellorId = action.payload.counsellorId;
			})
			.addCase(getAvailableSlot.rejected, (state) => {
				state.loading = false;
				state.availableSlots = [];
			});
	},
});

export const { clearTalkToExpert, setTalkToExpertOpen } =
	talkToExpertSlice.actions;
export default talkToExpertSlice.reducer;
